import React from 'react'
import PropTypes from 'prop-types'
import { useLocale } from '~/components/LocaleContext'
import Money from '~/utils/money'

const Price = ({ money }) => {
  const locale = useLocale()

  if (!money) return null

  const formattedAmount = new Money(money, locale).format()

  return <>{formattedAmount}</>
}

Price.propTypes = {
  money: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  }),
}

export default Price
